/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationDto } from '../../models/organization-dto';

export interface OrganizationsAllGet$Json$Params {
}

export function organizationsAllGet$Json(http: HttpClient, rootUrl: string, params?: OrganizationsAllGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
  const rb = new RequestBuilder(rootUrl, organizationsAllGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationDto>>;
    })
  );
}

organizationsAllGet$Json.PATH = '/organizations/all';
